import React from 'react';
import { Grid, Typography } from '@mui/material';
import { EMPTY } from '../../utils/formatters';

/**
 * Label/value pairs laid out in a responsive grid. Values may be strings or
 * elements; empty values render as a dash so the grid never has holes.
 */
const DetailList = ({ items, columns = 2, dense = false }) => (
  <Grid container spacing={dense ? 2 : 3}>
    {items
      .filter((item) => item && !item.hidden)
      .map((item) => (
        <Grid item key={item.label} xs={12} sm={item.span === 'full' ? 12 : 12 / columns}>
          <Typography
            variant="caption"
            component="div"
            color="text.secondary"
            sx={{ fontWeight: 600, letterSpacing: '0.04em', textTransform: 'uppercase', mb: 0.25 }}
          >
            {item.label}
          </Typography>
          {typeof item.value === 'string' || typeof item.value === 'number' || !item.value ? (
            <Typography
              variant="body1"
              sx={{ whiteSpace: item.multiline ? 'pre-wrap' : 'normal', overflowWrap: 'anywhere' }}
            >
              {item.value === null || item.value === undefined || item.value === '' ? EMPTY : item.value}
            </Typography>
          ) : (
            item.value
          )}
        </Grid>
      ))}
  </Grid>
);

export default DetailList;
